import React from "react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { MessagingSettingsTab } from "./utils/types";
import { useMessagingPageTab } from "./hooks/useMessagingPageTab";
import { useMessagingSettingsForm } from "./hooks/useMessagingSettingsForm";
import { ArrivalMessageCard } from "./components/ArrivalMessageCard";
import { BookingConfirmationCard } from "./components/BookingConfirmationCard";
import { EmailTemplatesCard } from "./components/EmailTemplatesCard";
import { MessagingPageTabsNav } from "./components/MessagingPageTabsNav";
import { useCurrentHotelId } from "@/hooks/useCurrentHotelId";

export const MessagingSettingsPage: React.FC = () => {
  const { pageTab, handlePageTabChange } = useMessagingPageTab();
  const form = useMessagingSettingsForm();
  const hotelId = useCurrentHotelId();

  return (
    <div className="flex flex-col gap-6 p-12">
      <Tabs
        value={pageTab}
        onValueChange={handlePageTabChange}
        className="w-full"
      >
        <MessagingPageTabsNav />

        <TabsContent value={MessagingSettingsTab.ARRIVAL} className="mt-0">
          <ArrivalMessageCard
            channel={form.channel}
            onChannelChange={form.setChannel}
            senderType={form.senderType}
            onSenderTypeChange={form.setSenderType}
            staffId={form.staffId}
            onStaffIdChange={form.setStaffId}
            fallback={form.fallback}
            onFallbackChange={form.setFallback}
            staffOptions={form.staffOptions}
            selectedStaff={form.selectedStaff}
            onCancel={form.handleArrivalCancel}
            onSave={form.handleArrivalSave}
            isSaving={form.isArrivalSavePending}
          />
        </TabsContent>

        <TabsContent value={MessagingSettingsTab.BOOKING} className="mt-0">
          <BookingConfirmationCard
            bookingAutoSend={form.bookingAutoSend}
            onBookingAutoSendChange={form.setBookingAutoSend}
            bookingAfterValue={form.bookingAfterValue}
            onBookingAfterValueChange={form.onBookingAfterValueChange}
            bookingAfterUnit={form.bookingAfterUnit}
            onBookingAfterUnitChange={form.setBookingAfterUnit}
            bookingReminderDays={form.bookingReminderDays}
            onReminderDaysChange={form.onReminderDaysChange}
            channel={form.bookingChannel}
            onChannelChange={form.setBookingChannel}
            senderType={form.bookingSenderType}
            onSenderTypeChange={form.setBookingSenderType}
            staffId={form.bookingStaffId}
            onStaffIdChange={form.setBookingStaffId}
            fallback={form.bookingFallback}
            onFallbackChange={form.setBookingFallback}
            staffOptions={form.staffOptions}
            selectedStaff={form.selectedBookingStaff}
            onCancel={form.handleBookingCancel}
            onSave={form.handleBookingSave}
            isSaving={form.isBookingSavePending}
          />
        </TabsContent>

        <TabsContent
          value={MessagingSettingsTab.EMAIL_TEMPLATES}
          className="mt-0"
        >
          <EmailTemplatesCard hotelId={hotelId} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
